import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Inject,
  Input, OnChanges,
  OnDestroy,
  OnInit, Output, SimpleChanges
} from "@angular/core";
import {DOCUMENT} from "@angular/common";
import {FormControl, FormGroup} from "@angular/forms";
import {TypeUtils} from "../../utils/type-utils";
import {CountryISO} from "ngx-intl-tel-input-gg";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-phone-number',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ds-phone-number.component.html',
    styleUrls: ['./ds-phone-number.component.scss'],
    standalone: false
})
export class DsPhoneNumberComponent implements OnInit, OnChanges, OnDestroy {

  @Input() value?: string;
  @Input() notValid?: boolean;
  @Output() public phoneNumber = new EventEmitter<any['value']>();
  @Output() public validPhoneForm = new EventEmitter<any>();
  public  phoneForm: FormGroup;
  public  phoneDefaultNumber: string = '+1';
  public  validForm: boolean = true;
  public  selectedCountryISO = CountryISO.UnitedStates;
  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.phoneForm = new FormGroup({
      'phone': new FormControl(this.value || this.phoneDefaultNumber),
    });

    // Subscribe to changes
    this.phoneForm.get('phone').valueChanges.subscribe(value => {
      if (!TypeUtils.isNull(value) && !TypeUtils.isUndefined(value) && !TypeUtils.isString(value)) {
        const phoneNumberFormatted = this._formatString(value?.number);
        this.phoneNumber.emit(phoneNumberFormatted);
        this._isValidPhoneNumber(phoneNumberFormatted);
        /*this.phoneForm.get('phone').setValue(this._formatString(number));*/
      }
    });
  }

  private _isValidPhoneNumber(number) {
    const regex = /^\+[0-9]{3,}$/;
    this.validForm = !!regex.test(number);
    this.validPhoneForm.emit(this.validForm);
  }

  public onCountryChange(country) {
    const number = country?.dialCode;
    this.phoneNumber.emit(this._formatString(number));
    this.phoneForm.get('phone').setValue(this._formatString(number));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['value'] && !TypeUtils.isNull(changes['value'].currentValue)) {
      this.value = changes['value'].currentValue;
      this.phoneForm && this.phoneForm.get('phone').setValue(this.value);
    }
  }

  private _formatString(input: string): string {
    if (typeof input !== 'string') {
      return '';
    }
    // Remove '+' symbol if it exists
    let formattedString = input.replace(/\s/g, '').replace(/-/g, '').replace(/^\+/, '');

    // Add '+' symbol to the beginning of the string
    formattedString = '+' + formattedString;
    return formattedString;
  }

  ngOnDestroy(): void {
    // Clean up any resources here
  }
}
